import { ArrowDown } from "flowbite-react-icons/outline";
import { useMetaTags } from "react-metatags-hook";
import { useLocation } from "react-router";
import Button from "@/components/buttons/button.jsx";
import PageHeader from "@/components/layout/page-header.jsx";
import CarouselWrapper from "@/components/shared/carousel/carousel-wrapper.jsx";
import { graphics } from "@/data/graphics.js";
import { getAssetImageUrl } from "@/util/common.js";
import { defaultOpenGraphImage, isTestMode } from "@/util/const.js";
import Features from "../shared/features.jsx";
import HeroPageLayout from "./hero.page-layout.jsx";

export default function GraphicsBundlePageLayout() {
  const location = useLocation();
  const page = location.pathname.split("graphics/")[1].split("/")[0];
  const { name, description, shortDescription, features, images, downloadLink } = graphics[page];
  const links = [{ title: "Graphics and Assets", href: "/graphics" }, { title: name }];

  let featuresBlock, metaImage;

  if (images && images.length > 0) {
    metaImage = getAssetImageUrl(images[0]);
  } else {
    metaImage = defaultOpenGraphImage;
  }

  useMetaTags(
    {
      title: `${name} | ${isTestMode ? "" : "St. Jude "}Play Live Tools`,
      description: description || shortDescription,
      openGraph: {
        image: metaImage,
        description: description || shortDescription,
      },
    },
    [name, description, shortDescription, metaImage],
  );

  if (features?.length) {
    featuresBlock = (
      <div className="features mb-6 flex-grow">
        <h1 className="text-xl mb-2 font-bold">Features:</h1>
        <Features features={features} />
      </div>
    );
  }

  return (
    <HeroPageLayout>
      <div className="flex flex-col relative">
        <PageHeader
          name={name}
          description={description || shortDescription}
          links={links}
          className="mb-0 ml-6"
        />
        <div className="flex flex-col ml-6">
          <CarouselWrapper constrainWidth images={images} />
          <div className={`relative mt-7`}>
            {featuresBlock}
            <Button
              mode="link"
              analyticsTrackingName="download-graphics-bundle"
              href={downloadLink}
            >
              <ArrowDown /> Download Bundle
            </Button>
          </div>
        </div>
      </div>
    </HeroPageLayout>
  );
}
